'use client';

import React, { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { pageLoadingStore, initializeHeroImageDelay } from '@/stores/pageLoadingStore';

interface HeroImageWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const HeroImageWrapper = ({ children, className = '' }: HeroImageWrapperProps) => {
  const snap = useSnapshot(pageLoadingStore);

  // Initialize the hero image delay system
  useEffect(() => {
    initializeHeroImageDelay();
  }, []);

  const heroImageClass = snap.isHeroImageAnimationReady ? 'hero-image-loaded' : 'hero-image-loading';

  return (
    <div className={`${heroImageClass} ${className}`}>
      {children}
    </div>
  );
};

export default HeroImageWrapper;
